module.exports = "images/Melbourne_DFM2-01-svg (1) (2).svg";